// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styling for info-box */
.info-box-map {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    padding: 3px;
    margin-bottom: 8px;
    border-radius: 5px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
  
  .info-box-icon-map {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 20px;
    border-radius: 5px;
  }
  
  /* Specific background colors */
  .red-bg {
    background-color: red;
  }
  
  .cyan-bg {
    background-color: cyan;
  }
  
  .yellow-bg {
    background-color: #ffbf00;
  }
  
  .green-bg {
    background-color: green;
  }
  
  /* Text styling */
  .info-box-content-map {
    display: flex;
    flex-direction: column;
  }
  
  .small-text {
    font-size: 10px;
  }
  
  /* Responsive styles */
  @media (max-width: 768px) {
    .small-box {
      width: 100%;
      height: auto;
    }
  
    .info-box-icon-map {
      width: 20px;
      height: 30px;
    }
  
    .small-text {
      font-size: 8px;
    }
  }
  
  @media (max-width: 576px) {
    .small-box {
      padding: 5px;
    }
  
    .info-box-icon-map {
      width: 20px;
      height: 30px;
    }
  
    .small-text {
      font-size: 6px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Analytics/Procurement/map.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA,+BAA+B;EAC/B;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,cAAc;IAChB;EACF;;EAEA;IACE;MACE,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,cAAc;IAChB;EACF","sourcesContent":["/* General styling for info-box */\n.info-box-map {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ddd;\n    padding: 3px;\n    margin-bottom: 8px;\n    border-radius: 5px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  }\n  \n  .info-box-icon-map {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    margin-right: 20px;\n    border-radius: 5px;\n  }\n  \n  /* Specific background colors */\n  .red-bg {\n    background-color: red;\n  }\n  \n  .cyan-bg {\n    background-color: cyan;\n  }\n  \n  .yellow-bg {\n    background-color: #ffbf00;\n  }\n  \n  .green-bg {\n    background-color: green;\n  }\n  \n  /* Text styling */\n  .info-box-content-map {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .small-text {\n    font-size: 10px;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 768px) {\n    .small-box {\n      width: 100%;\n      height: auto;\n    }\n  \n    .info-box-icon-map {\n      width: 20px;\n      height: 30px;\n    }\n  \n    .small-text {\n      font-size: 8px;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .small-box {\n      padding: 5px;\n    }\n  \n    .info-box-icon-map {\n      width: 20px;\n      height: 30px;\n    }\n  \n    .small-text {\n      font-size: 6px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
